import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { translate } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

import { environment } from '../../../../../environments/environment';
import { Dashboard, DashboardService } from '../../../../providers/bridge-api/dashboard.service';
import { SystemService } from '../../../../services/system.service';

export interface ShareDashboardDialogOptions {
  dashboard: Dashboard;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-share-dashboard-dialog',
  templateUrl: './share-dashboard-dialog.component.html',
  styleUrls: ['./share-dashboard-dialog.component.scss'],
  standalone: false,
})
export class ShareDashboardDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  linkGenerated = false;
  isGenerating = false;

  readonly dropdownOptions: (DropdownObject & { value: number })[] = [
    { title: translate('share-dashboard.one-day'), id: '0', value: 1440 },
    { title: translate('share-dashboard.one-week'), id: '1', value: 10080 },
    { title: translate('share-dashboard.one-month'), id: '2', value: 312480 },
  ];
  shareValue = '1';

  constructor(
    private dialogRef: MatDialogRef<ShareDashboardDialogComponent>,
    private systemService: SystemService,
    private dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) private options?: ShareDashboardDialogOptions
  ) {
    if (environment.name === 'dev') {
      this.dropdownOptions.push({
        title: translate('share-dashboard.ten-minutes'),
        id: '3',
        value: 10,
        subtitle: translate('share-dashboard.only-in-dev'),
      });
    }
  }

  public async generate() {
    this.isGenerating = true;
    const accessToken = await this.dashboardService.shareDashboard(this.options.dashboard, {
      expireAfterMinutes: this.dropdownOptions[parseInt(this.shareValue, 10)].value,
    });
    const url = `${location.href}?dashToken=${accessToken}`;
    this.systemService.copyToClipboard(url);
    this.linkGenerated = true;
    this.isGenerating = false;
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
